import React from 'react';

import { FloatingButton } from '~ui-kit';

import useQRCodeReader from './useQRCodeReader';

const QRCodeButton = ({ onRead }) => {
  const openQRCodeReader = useQRCodeReader({ onRead });

  if (!window.cordova) return null;

  return (
    <FloatingButton
      onClick={openQRCodeReader}
      title="Lue QR-koodi"
      faIcon="fa-qrcode"
    />
  );
};

export default QRCodeButton;
